import axios from 'axios'
import * as types from './types'

export default {
  [types.GET_COPILOT_INDICATORS]: ({ }, payload) => axios.get('/api/copilot/indicators', { params: payload })
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  [types.GET_COPILOT_AUDIT]: ({ }, payload) => axios.get('/api/copilot/audit', { params: payload })
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
}
